import { defineStore } from 'pinia';

export interface DraggedItem {
    editable?: boolean;
    [key: string]: unknown;
}

export interface SaasDraggableState {
    draggedItem: DraggedItem | null;
}

export const useSaasDraggableStore = defineStore('saasDraggable', {
    state: (): SaasDraggableState => ({
        draggedItem: null,
    }),
    actions: {
        updateDraggedItem(item: DraggedItem | null): void {
            this.draggedItem = item;
        },
    },
});
